import SearchModel from'./SearchModel';
class BSModel {
    id           = -1
    lac          = ""
    cid          = ""
    az           = ""
    address      = ""
    descBS       = ""
    lat = 0.0;
	lon = 0.0;
	band = "";
	mnc = 0;
	mcc = 0;
    searchModel = null;
}

export default BSModel